import { markdown } from '@topwrite/common';
import { mdastToSlate } from './mdast-to-slate';
import { Descendant } from 'slate';

export default (text: string): Descendant[] => {

    const md = markdown();

    const tree = md.parse(text);
    const root = md.runSync(tree);

    return mdastToSlate(root);
}
